if (!customElements.get("purchase-options")) {
  customElements.define(
    "purchase-options",
    class PurchaseOptions extends HTMLElement {
      connectedCallback() {
        this.planInput = this.querySelector("[data-selling-plan-input]");
        this.details = this.querySelector("[data-subscription-details]");
        this.options = Array.from(
          this.querySelectorAll(".f-purchase-options__option")
        );

        this.addEventListener("change", this.onChange.bind(this));
        this.syncSelection();
      }

      onChange(event) {
        if (event.target.matches('input[type="radio"]')) {
          this.syncSelection();
        }
      }

      getSellingPlanId() {
        const variantDataElement = this.querySelector(
          "[data-current-variant]"
        );
        if (!variantDataElement) return "";

        const currentVariant = JSON.parse(variantDataElement.textContent);
        return currentVariant?.selling_plan_allocations?.[0]?.selling_plan_id || "";
      }

      syncSelection() {
        const selectedInput = this.querySelector(
          'input[type="radio"]:checked'
        );
        const isSubscription = selectedInput?.value === "subscription";

        if (this.planInput) {
          if (isSubscription && !this.planInput.value) {
            const sellingPlanId = this.getSellingPlanId();
            this.planInput.value = sellingPlanId;
            this.planInput.setAttribute("value", sellingPlanId);
          }
          this.planInput.disabled = !isSubscription;
        }

        if (this.details) {
          this.details.hidden = !isSubscription;
        }

        this.options.forEach((option) => {
          const input = option.querySelector('input[type="radio"]');
          option.classList.toggle("is-selected", input?.checked === true);
        });
      }
    }
  );
}
